/* OPTIONLESS 2026 – theme.js (kein Framework, kein jQuery) */
(function () {
  'use strict';
  var OL = window.OL || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };
  function money(cents) {
    var fmt = OL.moneyFormat || '{{amount}}€';
    var v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_with_comma_separator') return v.replace('.', ',');
      if (key === 'amount_no_decimals') return String(Math.round(cents / 100));
      if (key === 'amount_no_decimals_with_comma_separator') return String(Math.round(cents / 100));
      return v;
    });
  }
  OL.money = money;
  function shortSize(t) { return t.replace('X-Small', 'XS').replace('X-Large', 'XL').replace('Small', 'S').replace('Medium', 'M').replace('Large', 'L'); }

  /* Toast */
  var toastTimer;
  function toast(msg) {
    var t = $('.toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    requestAnimationFrame(function () { t.classList.remove('is-hidden'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.add('is-hidden'); setTimeout(function () { t.hidden = true; }, 300); }, 2800);
  }
  OL.toast = toast;

  /* Header: Höhe, Ausblenden beim Runterscrollen, transparent über Hero */
  var headerSection = $('.section-header');
  var header = $('[data-header]');
  function setHeaderH() { if (headerSection) root.style.setProperty('--header-h', headerSection.offsetHeight + 'px'); }
  setHeaderH();
  if (headerSection && 'ResizeObserver' in window) new ResizeObserver(setHeaderH).observe(headerSection);
  var overlay = header && header.hasAttribute('data-overlay');
  if (overlay) document.body.classList.add('has-overlay-header');
  var hideOnScroll = header && header.getAttribute('data-hide') === 'true';
  var lastY = window.scrollY, ticking = false;
  function onScroll() {
    var y = window.scrollY;
    if (overlay) header.classList.toggle('is-solid', y > 40);
    if (hideOnScroll && headerSection && !root.classList.contains('lock')) {
      var delta = y - lastY;
      if (Math.abs(delta) > 4) {
        var hide = delta > 0 && y > 240;
        headerSection.classList.toggle('is-hidden', hide);
        root.style.setProperty('--sticky-top', hide ? '0px' : 'var(--header-h)');
      }
    }
    lastY = y; ticking = false;
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  /* Ankündigungsleiste */
  $$('[data-announcement]').forEach(function (bar) {
    var msgs = $$('.announcement__msg', bar); if (msgs.length < 2 || reduced) return;
    var i = 0, speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
    setInterval(function () {
      if (document.hidden) return;
      msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active');
    }, speed);
  });

  /* Drawer (native dialog) */
  var lastTrigger = null;
  function openDrawer(id, trigger) {
    var d = document.getElementById(id); if (!d || d.open) return;
    lastTrigger = trigger || document.activeElement;
    $$('dialog.drawer[open]').forEach(function (o) { if (o !== d) closeDrawer(o, true, true); });
    root.classList.add('lock');
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    d.scrollTop = 0; d.scrollLeft = 0;
    var panel = $('.drawer__panel', d);
    if (panel) {
      if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
      try { panel.focus({ preventScroll: true }); } catch (e) {}
      void panel.getBoundingClientRect();
    }
    d.classList.add('is-open');
    if (trigger && trigger.setAttribute && trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'true');
    d.dispatchEvent(new CustomEvent('drawer:open'));
  }
  function closeDrawer(d, instant, keepLock) {
    if (!d || !d.open) return;
    d.classList.remove('is-open');
    var done = function () {
      if (d.open) { if (typeof d.close === 'function') d.close(); else d.removeAttribute('open'); }
      if (!keepLock && !$('dialog.drawer[open]')) root.classList.remove('lock');
      if (!keepLock && lastTrigger && lastTrigger.focus && document.contains(lastTrigger)) {
        if (lastTrigger.hasAttribute && lastTrigger.hasAttribute('aria-expanded')) lastTrigger.setAttribute('aria-expanded', 'false');
        lastTrigger.focus({ preventScroll: true });
      }
    };
    if (instant || reduced) return done();
    var panel = $('.drawer__panel', d); var fired = false;
    var end = function () { if (fired) return; fired = true; done(); };
    if (panel) panel.addEventListener('transitionend', end, { once: true });
    setTimeout(end, 450);
  }
  OL.openDrawer = openDrawer; OL.closeDrawer = closeDrawer;
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      var id = opener.getAttribute('data-open');
      if (document.getElementById(id)) { e.preventDefault(); openDrawer(id, opener); }
      return;
    }
    var closer = e.target.closest('[data-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('dialog')); }
  });
  document.addEventListener('cancel', function (e) {
    if (e.target.matches && e.target.matches('dialog.drawer')) { e.preventDefault(); closeDrawer(e.target); }
  }, true);

  /* Warenkorb */
  function updateCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; }); }
  function renderCart(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var count = doc.querySelector('[data-cart-count-src]');
    if (count) updateCount(parseInt(count.getAttribute('data-cart-count-src'), 10) || 0);
    var fresh = doc.querySelector('[data-cart-content]');
    var cur = $('[data-cart-content]');
    if (fresh && cur) cur.replaceWith(document.importNode(fresh, true));
    if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) { try { Shopify.PaymentButton.init(); } catch (e) {} }
  }
  function cartFetch(url, body) {
    var drawer = $('#cart-drawer'); if (drawer) drawer.classList.add('is-busy');
    body.sections = ['cart-drawer']; body.sections_url = window.location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .finally(function () { if (drawer) drawer.classList.remove('is-busy'); });
  }
  OL.addToCart = function (items, btn) {
    if (btn) btn.classList.add('is-loading');
    return cartFetch(OL.routes.cart_add + '.js', { items: items })
      .then(function (res) {
        renderCart(res.sections);
        var qa = $('#quick-add'); if (qa && qa.open) closeDrawer(qa, true, true);
        openDrawer('cart-drawer');
      })
      .catch(function (err) { toast((err && (err.description || err.message)) || OL.t.error); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  };
  function changeLine(key, qty) {
    return cartFetch(OL.routes.cart_change + '.js', { id: key, quantity: qty }).then(function (r) { renderCart(r.sections); }).catch(function (err) { toast((err && err.description) || OL.t.error); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (b) {
      e.preventDefault();
      var line = b.closest('[data-line]'); var input = $('input', line); var q = parseInt(input.value, 10) || 0;
      changeLine(line.getAttribute('data-line'), b.getAttribute('data-qty') === 'plus' ? q + 1 : Math.max(0, q - 1));
      return;
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-remove'), 0); return; }
    var up = e.target.closest('[data-upsell-add]');
    if (up) { e.preventDefault(); OL.addToCart([{ id: parseInt(up.getAttribute('data-upsell-add'), 10), quantity: 1 }], up); }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-line] input')) changeLine(e.target.closest('[data-line]').getAttribute('data-line'), Math.max(0, parseInt(e.target.value, 10) || 0));
  });

  /* Produktformular */
  function initProduct(form) {
    var wrap = form.closest('[data-product]'); if (!wrap) return;
    var dataEl = $('script[data-variants]', wrap); if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = $('input[name="id"]', form);
    var btn = $('[data-atc]', form);
    var priceEl = $('[data-price]', wrap);
    var stockEl = $('[data-stock]', wrap);
    var notify = $('[data-notify]', wrap);
    var sticky = $('[data-sticky-atc]', wrap);
    var lowT = parseInt(wrap.getAttribute('data-low'), 10) || 0;
    var sets = $$('fieldset[data-option]', wrap);
    function selected() { return sets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function find(opts) { return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }); }
    function markAvailability(opts) {
      sets.forEach(function (fs, idx) {
        $$('.opt-btn', fs).forEach(function (lab) {
          var val = $('input', lab).value;
          var ok = variants.some(function (v) {
            if (!v.available || v.options[idx] !== val) return false;
            return v.options.every(function (o, i) { return i === idx || opts[i] === null || o === opts[i]; });
          });
          lab.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    function update(fromUser) {
      var opts = selected();
      markAvailability(opts);
      $$('[data-selected-value]', wrap).forEach(function (l, i) { l.textContent = opts[i] || ''; });
      var v = opts.indexOf(null) > -1 ? null : find(opts);
      if (!btn) return;
      if (!v) {
        btn.disabled = true; btn.textContent = opts.indexOf(null) > -1 ? btn.getAttribute('data-choose') : OL.t.unavailable;
        if (stockEl) stockEl.hidden = true; if (notify) notify.hidden = true;
        return;
      }
      idInput.value = v.id;
      if (priceEl) {
        var now = $('.price__now', priceEl); if (now) now.textContent = money(v.price);
        var was = $('.price__was', priceEl);
        if (v.compare_at_price > v.price) {
          if (!was) { was = document.createElement('s'); was.className = 'price__was'; now.after(was); }
          was.textContent = money(v.compare_at_price); was.hidden = false;
        } else if (was) { was.hidden = true; }
      }
      btn.disabled = !v.available;
      btn.textContent = v.available ? OL.t.addToCart : OL.t.soldOut;
      if (notify) notify.hidden = v.available;
      if (stockEl) {
        stockEl.hidden = false; stockEl.className = 'stock-note';
        if (!v.available) { stockEl.classList.add('stock-note--out'); stockEl.textContent = stockEl.getAttribute('data-out'); }
        else if (v.tracked && v.qty > 0 && v.qty <= lowT) { stockEl.textContent = stockEl.getAttribute('data-low'); }
        else { stockEl.classList.add('stock-note--ok'); stockEl.textContent = stockEl.getAttribute('data-ok'); }
      }
      if (sticky) {
        var sb = $('.btn', sticky); sb.disabled = !v.available; sb.textContent = v.available ? OL.t.addToCart : OL.t.soldOut;
        var sp = $('[data-sticky-price]', sticky); if (sp) sp.textContent = money(v.price) + (v.title !== 'Default Title' ? ' · ' + shortSize(v.title) : '');
      }
      if (fromUser) {
        if (v.media_id) {
          var slide = $('[data-media-id="' + v.media_id + '"]', wrap); var gal = slide && slide.parentElement;
          if (slide && gal && window.matchMedia('(max-width: 989px)').matches) gal.scrollTo({ left: slide.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
        }
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    wrap.addEventListener('change', function (e) { if (e.target.closest('fieldset[data-option]')) update(true); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      OL.addToCart([{ id: parseInt(idInput.value, 10), quantity: 1 }], btn);
    });
    if (sticky && btn) {
      $('.btn', sticky).addEventListener('click', function () {
        if (selected().indexOf(null) > -1) { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        if (form.requestSubmit) form.requestSubmit(); else btn.click();
      });
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(btn);
    }
    update(false);
  }
  $$('form[data-product-form]').forEach(initProduct);

  /* Galerie-Punkte */
  $$('[data-gallery]').forEach(function (g) {
    var dots = $$('.gallery__dots i', g.parentElement); if (dots.length < 2) return;
    var t = false;
    g.addEventListener('scroll', function () {
      if (t) return; t = true;
      requestAnimationFrame(function () {
        var i = Math.round(g.scrollLeft / Math.max(1, g.clientWidth));
        dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
        t = false;
      });
    }, { passive: true });
  });

  /* Schnell hinzufügen */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]'); if (!b) return;
    e.preventDefault();
    var url = b.getAttribute('data-quick-add').split('?')[0];
    var sheet = $('#quick-add'); if (!sheet) { window.location.href = url; return; }
    b.classList.add('is-loading');
    fetch(url + '.js').then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (p) {
      if (p.variants.length > 12) { window.location.href = url; return; }
      var body = $('[data-qa-body]', sheet);
      var title = p.title.replace(' – TEST', '');
      var img = p.featured_image ? '<div class="media"><img src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" width="88" height="110"></div>' : '<div class="media"></div>';
      var html = '<div class="qa-product">' + img + '<div><p style="font-size:16px">' + title + '</p><p class="muted small">' + money(p.price) + '</p></div></div>';
      html += '<p class="label" style="margin-bottom:12px">' + (p.variants.length > 1 ? sheet.getAttribute('data-variant-label') : '') + '</p><div class="qa-sizes">';
      p.variants.forEach(function (v) {
        var label = v.title === 'Default Title' ? OL.t.addToCart : shortSize(v.title);
        html += '<button type="button" class="btn btn--ghost" style="padding:0 8px;min-height:50px;font-size:13px;letter-spacing:.06em" ' + (v.available ? 'data-qa-variant="' + v.id + '"' : 'disabled aria-disabled="true"') + '>' + label + '</button>';
      });
      html += '</div><p style="margin-top:20px"><a class="text-link small" href="' + url + '">' + sheet.getAttribute('data-details') + '</a></p>';
      body.innerHTML = html;
      openDrawer('quick-add', b);
    }).catch(function () { window.location.href = url; }).finally(function () { b.classList.remove('is-loading'); });
  });
  document.addEventListener('click', function (e) {
    var v = e.target.closest('[data-qa-variant]'); if (!v) return;
    OL.addToCart([{ id: parseInt(v.getAttribute('data-qa-variant'), 10), quantity: 1 }], v);
  });

  /* Suche mit Vorschlägen */
  var sInput = $('[data-search-input]');
  if (sInput) {
    var so = $('#search-overlay');
    if (so) so.addEventListener('drawer:open', function () { setTimeout(function () { sInput.focus({ preventScroll: true }); }, 80); });
  }
  if (sInput && sInput.hasAttribute('data-predictive')) {
    var out = $('div[data-predictive]'); var timer;
    sInput.addEventListener('input', function () {
      clearTimeout(timer);
      var q = sInput.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch(OL.routes.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var items = (j.resources && j.resources.results && j.resources.results.products) || [];
            if (!items.length) { out.innerHTML = '<p class="muted small">' + out.getAttribute('data-empty') + '</p>'; return; }
            out.innerHTML = '<ul class="predictive__list" role="list">' + items.map(function (p) {
              var img = p.image ? '<div class="media"><img src="' + p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy" width="56" height="70"></div>' : '<div class="media"></div>';
              return '<li><a class="predictive__item" href="' + p.url + '">' + img + '<span><span style="display:block">' + p.title.replace(' – TEST', '') + '</span><span class="muted small">' + money(Math.round(parseFloat(p.price) * 100)) + '</span></span></a></li>';
            }).join('') + '</ul>';
          }).catch(function () {});
      }, 220);
    });
  }

  /* Tabs */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[role=tab]'); if (!tab) return;
    var list = tab.closest('[role=tablist]');
    $$('[role=tab]', list).forEach(function (t) {
      var on = t === tab; t.setAttribute('aria-selected', on);
      var p = document.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = !on;
    });
  });

  /* Filter & Sortierung */
  $$('[data-filter-form]').forEach(function (f) {
    f.addEventListener('submit', function () {
      $$('input', f).forEach(function (i) { if (i.type === 'number' && !i.value) i.disabled = true; });
    });
  });
  $$('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () { var u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); window.location.href = u.toString(); });
  });

  /* Newsletter-Pop-up: dezent, einmalig, nie über Warenkorb/Checkout */
  var pop = $('#newsletter-popup');
  if (pop) {
    if (/customer_posted=true/.test(window.location.search)) { store.set('ol_popup_done', '1'); }
    if (!store.get('ol_popup_done') && !/\/(cart|checkout|account|pages\/widerruf)/.test(window.location.pathname)) {
      var delay = (parseInt(pop.getAttribute('data-delay'), 10) || 15) * 1000;
      setTimeout(function () { if (!$('dialog.drawer[open]')) openDrawer('newsletter-popup'); }, delay);
    }
    pop.addEventListener('close', function () { store.set('ol_popup_done', '1'); });
    var popWa = $('[data-popup-wa]', pop); if (popWa) popWa.addEventListener('click', function () { store.set('ol_popup_done', '1'); setTimeout(function () { closeDrawer(pop, true); }, 300); });
  }

  /* Hero-Video: Reduced Motion respektieren, außerhalb des Viewports pausieren */
  $$('video[data-autoplay], .hero video').forEach(function (v) {
    if (reduced) { v.removeAttribute('autoplay'); v.pause(); return; }
    new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); }); }, { threshold: .1 }).observe(v);
  });

  /* Widerruf: 2 Schritte */
  $$('[data-withdraw]').forEach(function (w) {
    var s1 = $('[data-step="1"]', w), s2 = $('[data-step="2"]', w), bars = $$('.steps span', w);
    var next = $('[data-next]', w), back = $('[data-back]', w);
    if (next) next.addEventListener('click', function () {
      var ok = $$('[required]', s1).every(function (i) { return i.reportValidity(); }); if (!ok) return;
      $$('[data-echo]', s2).forEach(function (el) { var src = $('[name="' + el.getAttribute('data-echo') + '"]', w); el.textContent = src ? src.value : ''; });
      s1.hidden = true; s2.hidden = false; if (bars[1]) bars[1].classList.add('is-done');
      var f = $('button[type=submit]', s2); if (f) f.focus();
    });
    if (back) back.addEventListener('click', function () { s2.hidden = true; s1.hidden = false; if (bars[1]) bars[1].classList.remove('is-done'); });
  });
})();
